<script setup lang="ts">
import { storeToRefs } from "pinia";
import { UserSessionEntityType } from "~/modules/user/models/UserSessionEntityType.enum";
import { useUserSession } from "~/modules/user/stores/useUserSession";

defineProps<{
  isLoading: boolean;
  disabled?: boolean;
  context: "affiliation" | "delegation";
}>();

const showUploadIdCardModal = defineModel<boolean>("showUploadIdCardModal", {
  required: true,
});

const { userSession } = storeToRefs(useUserSession());

defineEmits(["uploadIdCard", "createOrganization"]);

const showAddMenu = ref(false);

const anchorClass = [
  "text-base",
  "font-medium",
  "!no-underline",
  "!text-inherit",
  "cursor-pointer",
];

const addMenuRef: Ref<HTMLElement | undefined> = ref();

// Close the "add menu" when clicking outside it
onClickOutside(addMenuRef, () => (showAddMenu.value = false));
</script>

<template>
  <add-bar
    v-if="!showAddMenu"
    :text="$t(`administration.relations.${context}s.add.button`)"
    button-type="tertiary"
    class="!text-gray-400 !bg-transparent !border-gray-400"
    :disabled="disabled"
    @click="showAddMenu = true"
  />

  <div
    v-if="showAddMenu"
    ref="addMenuRef"
    class="border border-gray-400 rounded-lg bg-white py-4 px-6 w-full text-primary-700 flex flex-col gap-4"
  >
    <a :class="anchorClass" @click.prevent.stop="showUploadIdCardModal = true">
      {{ $t("administration.relations.add.createLink") }}
    </a>

    <a
      v-if="userSession?.entity.type === UserSessionEntityType.BUSINESS_UNIT"
      :class="anchorClass"
      @click.prevent.stop="$emit('createOrganization')"
    >
      {{ $t("administration.relations.add.createOrganization") }}
    </a>
  </div>

  <upload-id-card-modal
    v-model:show="showUploadIdCardModal"
    :is-loading="isLoading"
    @upload-id-card="$emit('uploadIdCard', $event)"
  />
</template>
